import { TeamsResponse, createTeamsPayload, updateTeamsPayload } from '../features/questionnaire/questionnaireTypes';
import { del, get, post, put } from '../utils/api';
import { formatUrl } from '../utils/urlFormatter';


const fetch_locations = '/{0}/questionset.list';
const create_locations = '/{0}/questionset.add';
const update_location = '/{0}/{1}/questionset.update';
const fetch_locations_status = '/{0}/questionset.list';
const fetch_pipeline_details = '/{0}/{1}/questionset.detail'
const fetch_question_card_pipeline_details = '/{0}/{1}/questionset.jobQuestionset';
const assign_question_pipeline = '/{0}/{1}/{2}/questionset.assignJob'

const credentialsConfig = {
    withCredentials: true,
}


export const fetchLocationData = async (baseId: number): Promise<TeamsResponse> => {
    const fetch_location_data = formatUrl(fetch_locations, [baseId]);
    return get<TeamsResponse>(fetch_location_data, credentialsConfig);
};

export const fetchLocationDataStatus = async (baseId: number, status?: string): Promise<TeamsResponse> => {
    let fetch_location_data = formatUrl(fetch_locations_status, [baseId]);
    if (status) {
        fetch_location_data += `?status=${status}`;
    }
    return get<TeamsResponse>(fetch_location_data, credentialsConfig);
};


export const createLoationData = async (data: createTeamsPayload, userId: number): Promise<TeamsResponse> => {
    const base_create_location = formatUrl(create_locations, [userId]);
    return post<TeamsResponse>(base_create_location, data, credentialsConfig);
};


export const updateLocationData = async (id: number, baseId: number, data: updateTeamsPayload): Promise<TeamsResponse> => {
    const update_teams_data = formatUrl(update_location, [id, baseId]);
    return put<TeamsResponse>(update_teams_data, data, credentialsConfig);
};

export const fetchPipelineDetails = async (baseId: number, userId: string): Promise<TeamsResponse> => {
    const fetch_pipeline_details1 = formatUrl(fetch_pipeline_details, [baseId, userId]);
    return get<TeamsResponse>(fetch_pipeline_details1, credentialsConfig);
};

export const fetchJobQuestionPipelineDetails = async (baseId: number, JobId: string): Promise<TeamsResponse> => {
    const fetch_job_pipeline_details1 = formatUrl(fetch_question_card_pipeline_details, [baseId, JobId]);
    return get<TeamsResponse>(fetch_job_pipeline_details1, credentialsConfig);
};

export const assignJobQuestionPipelineDetails = async (baseId: number,userId: string, JobId: string): Promise<TeamsResponse> => {
    const assign_job_pipeline_details1 = formatUrl(assign_question_pipeline, [baseId,userId, JobId]);
    return post<TeamsResponse>(assign_job_pipeline_details1, {}, credentialsConfig);
};